import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Pipeline } from "../../../interfaces/Pipeline";
import { usePipelineStore } from "../../../stores/PipelineStore";
import { useSettingsStore } from "../../../stores/SettingsStore";
import { useIntl } from "react-intl";

const ComponentLabelsPipeline = ({ row }: { row: Pipeline }) => {
    const { selectMultiPipeline } = usePipelineStore()
    const { settings } = useSettingsStore()
    const intl = useIntl()

    const returnLabel = () => {
        // append semua label dari pipeline, product
        const labels = [...row.labels, ...row.leadProducts.flatMap(product => product.productLabels)]
        if (labels?.length && labels.length > 0) {
            if (labels.length === 1) {
                return (
                    <svg viewBox="0 0 24 24" height="19" width="20" fill="none" style={{ color: labels?.[0]?.color || "black" }} >
                        <path fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M15.393 5C16.314 5 17.167 5.447 17.685 6.182L21.812 12L21.346 12.657L17.686 17.816C17.166 18.553 16.314 19 15.393 19L5.81 18.992C4.262 18.992 3 17.738 3 16.19V7.81C3 6.261 4.262 5.008 5.809 5.008L15.393 5Z" />
                    </svg>
                )
            }
            else {
                return (
                    <div className="ps-1" style={{ color: labels?.[1]?.color || "black" }}>
                        <svg width="18px" height="15px" viewBox="0 0 18 15">
                            <path fill={`${labels?.[0]?.color || "black"}`} d="M11.208,3.925H2.236C1.556,3.925,1,4.565,1,5.357v7.213C1,13.362,1.556,14,2.236,14h8.972 c0.414,0,0.785-0.237,1.007-0.604l2.701-4.433L12.215,4.53C11.993,4.162,11.622,3.925,11.208,3.925z" />
                            <path fill="currentColor" d="M15.541,7.832L13.164,3.93 c-0.423-0.698-1.15-1.142-1.956-1.142H2.595V2.432C2.595,1.64,3.151,1,3.831,1h9.1c0.414,0,0.782,0.237,1.005,0.605l2.696,4.433 L15.541,7.832z" />
                        </svg>
                    </div>
                )
            }
        }
        return <></>
    }

    const returnLabelTooltip = () => {
        return (
            <Tooltip id='tooltip-labels'>
                <>

                    <div className="d-flex flex-column gap-1 mb-2">
                        {
                            row.labels?.length > 0 &&
                            <h6 className="w-100 text-start m-0 p-0">{settings.pipeline_title}</h6>
                        }
                        {row?.labels?.map((label, index) => (
                            <div key={index} style={{ display: 'flex', alignItems: 'center', whiteSpace: 'wrap' }}>
                                <svg viewBox="0 0 24 24" height="20" width="20" className="cursor-pointer me-2" preserveAspectRatio="xMidYMid meet" fill="none" style={{ color: label.color || "black", width: '20px', flexShrink: 0, marginBottom: "auto" }}>
                                    <path fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M15.393 5C16.314 5 17.167 5.447 17.685 6.182L21.812 12L21.346 12.657L17.686 17.816C17.166 18.553 16.314 19 15.393 19L5.81 18.992C4.262 18.992 3 17.738 3 16.19V7.81C3 6.261 4.262 5.008 5.809 5.008L15.393 5Z"></path>
                                </svg>
                                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {label.name}
                                </span>
                            </div>
                        ))
                        }
                    </div>
                    <div className="d-flex flex-column gap-1">
                        {
                            row.leadProducts?.flatMap(product => product.productLabels)?.length > 0 &&
                            <h6 className="w-100 text-start m-0 p-0">{intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PRODUCT' })}</h6>
                        }
                        {row.leadProducts.map((product, index) => {
                            const getProductLabels = product.productLabels?.map((label, index) => {
                                return (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center', whiteSpace: 'wrap' }}>
                                        <svg viewBox="0 0 24 24" height="20" width="20" className="cursor-pointer me-2" preserveAspectRatio="xMidYMid meet" fill="none" style={{ color: label.color || "black", width: '20px', flexShrink: 0, marginBottom: "auto" }}>
                                            <path fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M15.393 5C16.314 5 17.167 5.447 17.685 6.182L21.812 12L21.346 12.657L17.686 17.816C17.166 18.553 16.314 19 15.393 19L5.81 18.992C4.262 18.992 3 17.738 3 16.19V7.81C3 6.261 4.262 5.008 5.809 5.008L15.393 5Z"></path>
                                        </svg>
                                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            {label.name}
                                        </span>
                                    </div>
                                )
                            })
                            return getProductLabels
                        })
                        }
                    </div>
                </>
            </Tooltip>
        )
    }

    return (
        <span>
            <div>
                {selectMultiPipeline.isFeatureLabelEnabled &&
                    <OverlayTrigger
                        placement='right'
                        overlay={
                            returnLabelTooltip()
                        }
                    >
                        <span
                            id={`labels-${row.id}`}
                            className='cursor-pointer'
                            data-toggle='tooltip'
                            data-placement='right'
                            title=''
                        >
                            {returnLabel()}
                        </span>
                    </OverlayTrigger>
                }
            </div>
        </span>
    )
}

export default ComponentLabelsPipeline